import { SourceType } from '../models/sourcetype';
export enum proposalForEntity {
    ForSupplier = 1,
    ForTesla = 2
}

export enum Menu {
     PendingProposals = 1,
    // RejectedProposals = 2,
    PackageTemplates = 2,
    SearchPart = 3,
    HotRequests = 4,
    ReviewProposals = 5,
    PendingPhysicalInspection = 6,
    AdHocRequest = 7,
    CreateProposal = 8,
    ManagePackageEngineers = 9,
    ExemptParts = 10,
    SourceType = 11,
    BulkUpload = 12,
    BulkCopyProposals = 13,
    AdHocDueDateRequestDashboard = 14,
    SubmittedProposals = 15,
    ApprovedProposals = 16,
    SyncProposals = 19,
    AddPackageEngineer = 20,
    BulkUploadPackageTemplate = 21,
    AdminInfoButtons = 22,
    RequestEstimates = 23,
    Estimates = 24,
    CriticalParts = 25,
}

export enum ChartProposalStatus {
    Pending = 1,
    Submitted = 2,
    Approved = 3,
    Rejected = 4,
    ToBeReviewed = 5,
    Incomplete = 6
}

export enum ProposalPartOriginPropertyId {
    Country = 1,
    State = 2,
    City = 3,
    Full = 4
}
